export function numberToHtmlColor(value: number): string {
    const hex = (value & 0xffffff).toString(16).padStart(6, "0");
    return `#${hex}`;
}
